module.exports = __webpack_public_path__ + "static/media/ic-lightbulb.d0e90c09.svg";